import { render, staticRenderFns } from "./editPush.vue?vue&type=template&id=2c5fedff&scoped=true&"
import script from "./editPush.vue?vue&type=script&lang=js&"
export * from "./editPush.vue?vue&type=script&lang=js&"
import style0 from "./editPush.vue?vue&type=style&index=0&id=2c5fedff&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c5fedff",
  null
  
)

export default component.exports